import { IQueryConfigArgs } from "../../common/types";
import { db, collectionWithArgs } from "./firestoreService";
import {
  COLLECTION_HOTEL28355,
  COLLECTION_ROOM40231,
} from "./firebaseConstants";

export function fetchRoom40231FromFirestore(
  hotelId: string,
  args?: IQueryConfigArgs[],
) {
  const ref = db
    .collection(COLLECTION_HOTEL28355)
    .doc(hotelId)
    .collection(COLLECTION_ROOM40231);
  return collectionWithArgs(ref, args || []);
}
export function listenToRoom40231FromFirestore(hotelId: string, id: string) {
  return db
    .collection(COLLECTION_HOTEL28355)
    .doc(hotelId)
    .collection(COLLECTION_ROOM40231)
    .doc(id);
}
